export const languageFormatter = (lang: string) => lang.split('_')[0];
